import $, { timers } from 'jquery';
import Swiper, { Navigation, Thumbs, EffectFade } from 'swiper/core';
import fancybox from '@fancyapps/fancybox';
import LazyLoad from 'vanilla-lazyload';
Swiper.use([Navigation, Thumbs, EffectFade]);

class PdpGallery {
	constructor() {
		this.gallery = '#pdp-galleries';
		this.galleryThumb = '#pdp-thumbs';
		this.accordionCarousel = '.accordion-carousel';
		this.accordionItem = $('.pdp-accordion');
		this.accordionTitle = $('.pdp-accordion__title');
		this.accordionHeadBtn = $('.pdp-accordion__head-btn');
		this.tabNavItem = $('.tab-menu__link');
		this.tabContentItem = $('.tab__content-item');
		// this.init();
	}

	init() {
		var lazyImg = new LazyLoad({
			elements_selector: '.swiper-slider img',
		});

		var PdpGalleryThumb = new Swiper(this.galleryThumb, {
			slidesPerView: 'auto',
			spaceBetween: 14,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			loop: true,
			// lazy: {
			//     loadPrevNext: true,
			//     elementClass: 'lazy'
			// },
			breakpoints: {
				992: {
					direction: 'vertical',
					spaceBetween: 13,
					width: 56,
					height: 196,
				},
			},
			navigation: {
				nextEl: '.pdp-galleries-thumbs__button--next',
				prevEl: '.pdp-galleries-thumbs__button--prev',
			},
		});

		var PdpGallery = new Swiper(this.gallery, {
			spaceBetween: 0,
			speed: 1000,
			loop: true,
			// lazy: {
			//     loadPrevNext: true,
			//     elementClass: 'lazy'
			// },
			navigation: {
				nextEl: '.pdp-gallery__button--next',
				prevEl: '.pdp-gallery__button--prev',
			},
			thumbs: {
				swiper: PdpGalleryThumb,
			},
			on: {
				init: function () {
					lazyImg.update();
				},
			},
		});
		window.productSwiper = PdpGallery;

		//init accordion
		this.accordion();

		if ($('[data-fancybox="gallery"]').length) {
			$('[data-fancybox="gallery"]').fancybox({
				infobar: true,
				wheel: false,
				buttons: ['close'],
				btnTpl: {
					close:
						'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
						'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="68px" height="68px" viewBox="0 0 68 68" style="enable-background:new 0 0 68 68;" xml:space="preserve"> <circle class="st0" cx="34" cy="34" r="33.9" fill="#FFE100" stroke="#231F20" stroke-width="0.25" /> <path class="st1" d="M28,26.6c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L28,26.6z M39.2,40.6c0.4,0.4,1,0.4,1.4,0 c0.4-0.4,0.4-1,0-1.4L39.2,40.6z M26.6,28l12.6,12.6l1.4-1.4L28,26.6L26.6,28z" /> <path class="st1" fill="#231F20" d="M40.6,28c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L40.6,28z M26.6,39.2c-0.4,0.4-0.4,1,0,1.4 c0.4,0.4,1,0.4,1.4,0L26.6,39.2z M39.2,26.6L26.6,39.2l1.4,1.4L40.6,28L39.2,26.6z" /></svg>' +
						'</button>',
					// Arrows
					arrowLeft:
						'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
						'<div><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="28" cy="28" r="27.875" transform="rotate(-180 28 28)" fill="#FFE100" stroke="#231F20" stroke-width="0.25"/> <path d="M38 29C38.5523 29 39 28.5523 39 28C39 27.4477 38.5523 27 38 27L38 29ZM17.2929 27.2929C16.9024 27.6834 16.9024 28.3166 17.2929 28.7071L23.6569 35.0711C24.0474 35.4616 24.6805 35.4616 25.0711 35.0711C25.4616 34.6805 25.4616 34.0474 25.0711 33.6569L19.4142 28L25.0711 22.3431C25.4616 21.9526 25.4616 21.3195 25.0711 20.9289C24.6805 20.5384 24.0474 20.5384 23.6569 20.9289L17.2929 27.2929ZM38 27L18 27L18 29L38 29L38 27Z" fill="black"/> </svg></div>' +
						'</button>',
					arrowRight:
						'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
						'<div><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="28" cy="28" r="27.875" fill="#FFE100" stroke="#231F20" stroke-width="0.25"/> <path d="M18 27C17.4477 27 17 27.4477 17 28C17 28.5523 17.4477 29 18 29V27ZM38.7071 28.7071C39.0976 28.3166 39.0976 27.6834 38.7071 27.2929L32.3431 20.9289C31.9526 20.5384 31.3195 20.5384 30.9289 20.9289C30.5384 21.3195 30.5384 21.9526 30.9289 22.3431L36.5858 28L30.9289 33.6569C30.5384 34.0474 30.5384 34.6805 30.9289 35.0711C31.3195 35.4616 31.9526 35.4616 32.3431 35.0711L38.7071 28.7071ZM18 29H38V27H18V29Z" fill="black"/> </svg></div>' +
						'</button>',
					smallBtn:
						'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
						'<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
						'</button>',
				},
				parentEl: 'main.content',
			});
		}

		this.tab();

		// this.stickyAddToCart();

		new LazyLoad();
		this.initSupplementsCarousel();
		this.initSupplementAccordion();
	}

	accordion() {
		var _this = this;
		_this.initAccordionCarousel();
		// $('.pdp-accordions .pdp-accordion:first-child').addClass('open').find('.pdp-accordion__body').show();
		// console.log(this.accordionTitle);

		$('body').on('click', '.pdp-accordion__title', function (e) {
			// console.log(e);
			_this.initAccordionCarousel();
			if (
				$(this).parent().parent().is('.pdp-accordion') &&
				!$(this).parent().parent().hasClass('open')
			) {
				$('.pdp-accordion')
					.removeClass('open')
					.find('.pdp-accordion__body')
					.slideUp();
				$(this)
					.parents('.pdp-accordion')
					.addClass('open')
					.find('.pdp-accordion__body')
					.slideDown();
			} else {
				$(this)
					.parents('.pdp-accordion')
					.removeClass('open')
					.find('.pdp-accordion__body')
					.slideUp();
			}
		});
	}

	tab() {
		$('.tab-menu__link').each((i, el) => {
			$(el).on('click', (e) => {
				e.preventDefault();
				$('.tab-menu__link').removeClass('tab-menu__link--active');
				$(e.currentTarget).addClass('tab-menu__link--active');
				$('.tab__content-item').hide();
				$('.tab__content-item').eq(i).show();
			});
		});
	}

	initAccordionCarousel() {
		//init accordion carousel;
		if (
			$(this.accordionCarousel).length &&
			$(this.accordionCarousel).find('.swiper-slide').length
		) {
			var PdbAccordion = new Swiper(this.accordionCarousel, {
				speed: 600,
				spaceBetween: 21,
				slidesPerView: 'auto',
				loopAdditionalSlides: 0,
				loop: true,
				freeMode: true,
				freeModeSticky: true,
				initialSlide: 0,
				resizeObserver: true,
				autoplay: {
					delay: 3300,
					disableOnInteraction: false,
				},
				observeParents: true,
				breakpoints: {
					992: {
						slidesPerView: 'auto',
						spaceBetween: 30,
					},
				},
				navigation: {
					nextEl: '.pdp-carousel .swiper-button-next',
				},
			});
		}
	}

	stickyAddToCart() {
		var getHeaderHeight = $('.header:not(.shopify-section)').outerHeight();
		var offsetTopPosition = $('.benefits ').length
			? $('.benefits ').offset().top - getHeaderHeight
			: $('.pdp-accordions').length
			? $('.pdp-accordions').offset().top - getHeaderHeight
			: 0;
		// console.log(getHeaderHeight);

		$(window).on('scroll', () => {
			var scrollPosition = $(window).scrollTop();
			if (scrollPosition >= offsetTopPosition) {
				$('.pdp__addcart--sticky').fadeIn();
			} else {
				$('.pdp__addcart--sticky').fadeOut();
			}
		});

		$('.pdp__addcart--sticky').on('click', () => {
			if ($('.pdp__summary-inner .AddToCartForm:visible').length == 0) {
				var href = $('#out-of-stock-container').find('a').attr('href');
				window.location.href = href;
			} else {
				$('.pdp__addcart').trigger('click');
			}
			
			/*var atcButtonTop =
				$('.pdp__title').offset().top - (getHeaderHeight + 5);

			$('html,body').animate(
				{
					scrollTop: $('body').offset().top + atcButtonTop,
				},
				1000
			);*/
		});
	}
	initSupplementsCarousel() {
		  new Swiper('.supplements-carousel', {
			slidesPerView: 1,
			centeredSlides: true,
			centerInsufficientSlides: true,
			centeredSlidesBounds: true,
			spaceBetween: 45,
			loop: true,
			breakpoints: {
			  992: {
				slidesPerView: 2.2
			  }
			},
			lazy: {
			  loadPrevNextAmount: 2
			}
		  });
		}
	  initSupplementAccordion() {
		  $('body').on('click', ".supplement-benefit__accordion-title", function (e) {
			e.preventDefault();
			var element = $(e.currentTarget).parent();
	
			if (element.hasClass('open')) {
			  element.removeClass('open').find("> .supplement-benefit__accordion-desc").slideUp();
			} else {
			  element.siblings().removeClass('open').find("> .supplement-benefit__accordion-desc").slideUp();
			  element.addClass('open').find("> .supplement-benefit__accordion-desc").slideDown();
			}
		  });
		}

}
export default PdpGallery;
